import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Box, LoadingSpinner } from 'edenred-ui';

import { routerPaths } from '@epi-constants/routerPaths';
import { goToPage } from '@epi-actions/navigation';
import { getUserRoles } from '@epi-selectors/login';
import { HomeNotification } from '@epi-pages/Home/components';
import {
  isSignatory,
  isVoucherManager
} from '@epi-helpers/Menu/MenuItemsFactoryHelper';
import { useGetMetadataQuery } from '@epi-api/companyMetadata';
import { useHasVoucherOrdersQuery } from '@epi-api/vouchers';

import {
  OrderVouchersPanel,
  PaperVoucherError,
  RequestContact,
  VoucherOrderHistory
} from './components';
import { getVoucherPageVisibility } from '@epi-helpers/VouchersHelper';

const PaperVouchers: React.FC = () => {
  const {
    data: companyMetadata,
    isFetching,
    isSuccess
  } = useGetMetadataQuery();
  const { data: hasVouchers, isLoading: isLoadingVouchers } =
    useHasVoucherOrdersQuery();

  const roles = useSelector(getUserRoles);
  const dispatch = useDispatch();

  const hideVoucherOrderPage = !getVoucherPageVisibility(
    companyMetadata,
    hasVouchers
  );

  const enableVoucherOrderSection =
    companyMetadata?.orderVouchersEnabled ?? false;

  const voucherManagerOnly =
    !isSignatory({ roles }) && isVoucherManager({ roles });
  const isError = hideVoucherOrderPage && voucherManagerOnly;

  useEffect(() => {
    if (hideVoucherOrderPage && !isError && isSuccess) {
      dispatch(goToPage(routerPaths.home));
    }
  }, [hideVoucherOrderPage, isError, isSuccess, dispatch]);

  if (isFetching || isLoadingVouchers) return <LoadingSpinner />;

  if (isError) return <PaperVoucherError />;

  return (
    <Box pb={5}>
      {voucherManagerOnly && <HomeNotification />}
      <RequestContact />
      {enableVoucherOrderSection && <OrderVouchersPanel />}
      <VoucherOrderHistory />
    </Box>
  );
};

export default PaperVouchers;
